import { render, staticRenderFns } from "./ContainerDocu.vue?vue&type=template&id=33c32652&scoped=true"
import script from "./ContainerDocu.vue?vue&type=script&lang=js"
export * from "./ContainerDocu.vue?vue&type=script&lang=js"
import style0 from "./ContainerDocu.vue?vue&type=style&index=0&id=33c32652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c32652",
  null
  
)

export default component.exports